import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Spinner } from 'reactstrap'
import LoadingAbsolute from '../../LoadingAbsolute'
import Header from '../../Header'
import UserGreenSvg from '../../../assets/icons/UserGreenSvg'
import InfoCircleRedSvg from '../../../assets/icons/InfoCircleRedSvg'
import CreditCardGreenSvg from '../../../assets/icons/CreditCardGreenSvg'
import CardVisaSvg from '../../../assets/icons/CardVisaSvg'
import CardMasterSvg from '../../../assets/icons/CardMasterSvg'
import CalenderGreenSvg from '../../../assets/icons/CalenderGreenSvg'
import LockGreenSvg from '../../../assets/icons/LockGreenSvg'
import InputComp from '../../InputComp'
import axios from 'axios'
import PayModal from './PayModal'
import ErrorModal from '../../ErrorModal'
import usePayModal from '../../../hooks/usePayModal'
import useErrorModal from '../../../hooks/useErrorModal'
import ConditionsCheckBox from '../ApplicationsForm/ConditionsCheckBox'
import { useSelector } from 'react-redux'

const HobiBahceleriOdeme = () => {
  const { isVisible, message, showPay, closeError } = usePayModal()
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [kartNoError, setKartNoError] = useState(false)
  const [kartSahibiError, setKartSahibiError] = useState(false)
  const [kartYiliError, setKartYiliError] = useState(false)
  const [kartCVCError, setKartCVCError] = useState(false)
  const [btnOdemeMetni, setBtnOdemeMetni] = useState('Ödemeyi Tamamla')
  const [checkbox, setCheckbox] = useState(false)
  const [formData, setFormData] = useState({
    kartNo: '',
    kartSahibi: '',
    kartYili: '',
    kartCVC: '',
  })
  const [cardInfo, setCardInfo] = useState({
    type: null,
    isValid: true,
    isValidLength: false,
    showError: false,
  })

  const PageState = useSelector((state) => state.PageState.value)

  const { isVisible: errorIsVisible, message: errorMessage, showError, closeError: errorCloseError } = useErrorModal()

  useEffect(() => {
    const cleanNumber = formData.kartNo.replace(/\D/g, '')
    const cardType = detectCardType(cleanNumber)
    const isValidLength = cleanNumber.length === 16
    const isValid = validateCardNumber(cleanNumber)

    setCardInfo({
      type: cardType,
      isValid: isValid,
      isValidLength,
    })

    setBtnOdemeMetni('Ödemeyi Tamamla (' + (PageState?.ucret ?? '-') + '₺)')

    const messageHandler = (evt) => {
      if (evt.origin === 'https://app.yanibasimdakaratay.com') {
        const data = JSON.parse(evt.data)
        if (data?.action === 'closeModal') {
          closeError()
        } else {
          navigate('/hobiSuccess', {
            state: {
              id: data.paymentId,
            },
          })
        }
      }
    }

    window.addEventListener('message', messageHandler)

    // Cleanup function
    return () => {
      window.removeEventListener('message', messageHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, formData.kartNo, PageState.ucret])

  // Luhn algoritması ile kart numarası validasyonu
  const validateCardNumber = (number) => {
    const digits = number.replace(/\D/g, '')

    // Eksik numara kontrolü
    if (digits.length < 16) return true

    let sum = 0
    let isEven = false

    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = parseInt(digits[i], 10)

      if (isEven) {
        digit *= 2
        if (digit > 9) {
          digit -= 9
        }
      }

      sum += digit
      isEven = !isEven
    }

    return sum % 10 === 0
  }

  // Kart türünü tespit etme
  const detectCardType = (number) => {
    const cleanNumber = number.replace(/\D/g, '')

    if (cleanNumber.length < 4) return null

    // Visa: 4 ile başlar
    if (/^4/.test(cleanNumber)) {
      return 'visa'
    }

    // Mastercard: 51-55 ile başlar veya 2221-2720 aralığında başlar
    if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]2[0-1]/.test(cleanNumber)) {
      return 'mastercard'
    }

    return null
  }

  const CardLogo = ({ type }) => {
    if (!type) return <CreditCardGreenSvg width={'1rem'} />

    const logos = {
      visa: <CardVisaSvg width={'1.5rem'} />,
      mastercard: <CardMasterSvg width={'1rem'} />,
    }

    return logos[type] || <CreditCardGreenSvg width={'1rem'} />
  }

  const formatCardHolder = (value) => {
    const trMap = {
      i: 'İ',
      ı: 'I',
      ğ: 'Ğ',
      ü: 'Ü',
      ş: 'Ş',
      ö: 'Ö',
      ç: 'Ç',
    }

    return value
      .replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '')
      .split('')
      .map((letter) => trMap[letter] || letter.toUpperCase())
      .join('')
  }

  const formatCardNumber = (value) => {
    const numbers = value.replace(/\D/g, '')
    const trimmed = numbers.substring(0, 16)
    return trimmed.replace(/(\d{4})(?=\d)/g, '$1 ')
  }

  const formatExpiryDate = (value) => {
    const numbers = value.replace(/\D/g, '')
    const trimmed = numbers.substring(0, 4)
    if (trimmed.length > 2) {
      return `${trimmed.slice(0, 2)}/${trimmed.slice(2)}`
    }
    return trimmed
  }

  const formatCVV = (value) => {
    return value.replace(/\D/g, '').substring(0, 3)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    let formattedValue = value

    switch (name) {
      case 'kartNo':
        formattedValue = formatCardNumber(value)
        setKartNoError(false)
        break
      case 'kartSahibi':
        formattedValue = formatCardHolder(value)
        setKartSahibiError(false)
        break
      case 'kartYili':
        formattedValue = formatExpiryDate(value)
        setKartYiliError(false)
        break
      case 'kartCVC':
        formattedValue = formatCVV(value)
        setKartCVCError(false)
        break
      default:
        break
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }))
  }

  const validate = () => {
    const cleanCardNumber = formData.kartNo.replace(/\D/g, '')
    const kartNoValid = formData.kartNo.replace(/\s/g, '').length !== 16 || !validateCardNumber(cleanCardNumber)
    const kartSahibiValid = formData.kartSahibi.trim().length < 5
    const [month, year] = formData.kartYili.split('/')
    const kartYiliValid = !month || !year || month > 12 || month < 1
    const kartCVCValid = formData.kartCVC.length !== 3

    if (kartNoValid) {
      setKartNoError(true)
    }
    if (kartSahibiValid) {
      setKartSahibiError(true)
    }
    if (kartYiliValid) {
      setKartYiliError(true)
    }
    if (kartCVCValid) {
      setKartCVCError(true)
    }

    if (!checkbox) {
      showError('Başvuruyu tamamlamak için kullanım koşullarını kabul etmeniz gerekmektedir.')
      return false
    }

    return !kartNoValid && !kartSahibiValid && !kartYiliValid && !kartCVCValid
  }

  const onFinish = (e) => {
    e.preventDefault()
    if (validate()) {
      // axios
      //   .post(
      //     `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/hobi-bahceleri-basvuru`,
      //     {
      //       meslek: meslek,
      //     },
      //     {
      //       headers: {
      //         Authorization: JSON.parse(localStorage.getItem('token')),
      //       },
      //     }
      //   )
      //   .then((res) => {})

      setLoading(true)
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/hobi-bahceleri-basvuru/pay`,
          { ...formData, job: state?.meslek, unemployed: state?.unemployed, business: state?.isyeri },
          {
            headers: {
              Authorization: JSON.parse(localStorage.getItem('token')),
            },
          }
        )
        .then((res) => {
          showPay(res.data.html)
        })
        .catch((err) => {
          showError(err?.response?.data?.message)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        <div className='hobiWarning'>
          <div>
            <InfoCircleRedSvg width={'1rem'} />
          </div>
          <div>
            Hobi bahçeleri için başvuru ücreti <b>{PageState?.ucret ?? '-'}₺</b>'dir. Kura sonucuna göre hak sahibi olunamaması durumunda iadesi mümkün olmayacaktır.
          </div>
        </div>
        <div className='hobiTitle' style={{ fontSize: '16px' }}>
          Ödeme Bilgileri
        </div>
        <div className='userInfoDiv'>
          <InputComp
            type='text'
            name={'kartSahibi'}
            value={formData.kartSahibi}
            svg={<UserGreenSvg width={'1rem'} />}
            onChange={handleChange}
            placeholder='Kart Üzerindeki Ad Soyad'
            error={kartSahibiError}
            errorText={'Geçerli bir isim giriniz'}
          />
        </div>
        <div className='userInfoDiv' style={{ margin: '-.8rem 0 0 0' }}>
          <InputComp
            type='text'
            inputMode='numeric'
            name='kartNo'
            value={formData.kartNo}
            svg={<CardLogo type={cardInfo.type} />}
            onChange={handleChange}
            placeholder='Kart Numarası'
            error={kartNoError}
            errorText={'Geçerli bir kart numarası giriniz'}
          />
        </div>
        <div style={{ display: 'flex', gap: '.5rem' }}>
          <div className='' style={{ margin: '-.8rem 0 0 1.5rem' }}>
            <InputComp
              half
              type='text'
              inputMode='numeric'
              name='kartYili'
              value={formData.kartYili}
              svg={<CalenderGreenSvg width={'1rem'} />}
              onChange={handleChange}
              placeholder='Ay / Yıl'
              error={kartYiliError}
              errorText={'Geçerli bir tarih giriniz'}
            />
          </div>
          <div className='' style={{ margin: '-.8rem 1.5rem 0 0' }}>
            <InputComp
              half
              type='text'
              inputMode='numeric'
              name='kartCVC'
              value={formData.kartCVC}
              svg={<LockGreenSvg width={'1rem'} />}
              onChange={handleChange}
              placeholder='CVC'
              error={kartCVCError}
              errorText={'Geçerli bir CVC giriniz'}
            />
          </div>
        </div>
        <ConditionsCheckBox
          kisa_metin={'Karatay Belediyesi hobi bahçesi başvuru ve tahsis sözleşmesini, K.V.K.K. metnini okudum, kabul ediyorum.'}
          checkbox={checkbox}
          setCheckbox={setCheckbox}
          basvuru_sartlari_title={PageState?.basvuru_sartlari_title}
          basvuru_sartlari_aciklama={PageState?.basvuru_sartlari_aciklama}
          style={{ margin: '10px 25px' }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '2rem',
          }}
        >
          <Button
            block
            onClick={onFinish}
            style={{
              marginLeft: '1rem',
              marginRight: '1rem',
              backgroundColor: '#285843',
              borderRadius: '50px',
              padding: '.5rem 0',
            }}
          >
            {loading ? (
              <Spinner
                size={'sm'}
                // type="grow"
              />
            ) : (
              btnOdemeMetni
            )}
          </Button>
        </div>
      </div>
      <PayModal isVisible={isVisible} onClose={closeError} message={message} />
      <ErrorModal isVisible={errorIsVisible} onClose={errorCloseError} message={errorMessage} />
    </>
  )
}

export default HobiBahceleriOdeme
